import {
    type ViewStyle,
    type TextStyle,
    StyleSheet
} from "react-native";
import type {
    ColorFieldDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getInputTextStyle
} from "../../helpers/theme/input";
import {
    getFocusRingStyle
} from "../../helpers/theme/state";
import {
    getCornerStyle
} from "../../helpers/theme/corner";
import {
    webStyle
} from "../../utils";

const stylesheet = StyleSheet.create({
    input: {
        backgroundColor: "transparent",
        textAlignVertical: "center",
        includeFontPadding: false,
        alignSelf: "stretch",
        fontVariant: [
            "tabular-nums"
        ],
        borderWidth: 0,
        minWidth: 0,
        padding: 0,
        margin: 0,
        flex: 1
    },
    alphaInput: {
        backgroundColor: "transparent",
        textAlignVertical: "center",
        includeFontPadding: false,
        alignSelf: "stretch",
        fontVariant: [
            "tabular-nums"
        ],
        borderWidth: 0,
        minWidth: 0,
        padding: 0,
        margin: 0
    },
    swatch: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            cursor: "pointer"
        })
    },
    chevron: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            cursor: "pointer"
        })
    },
    affix: {
        ...webStyle({
            userSelect: "none"
        })
    },
    alphaGroup: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 0
    },
    surface: {
        overflow: "hidden",
        padding: 0
    }
});

export const useStyles = ({
    isChevronFocusVisible,
    shapeConfigs,
    currentSize,
    pointerType,
    typography,
    radiuses,
    borders,
    colors
}: ColorFieldDynamicStyleType) => {
    const styles = {
        chevron: {
            height: currentSize.actionSize,
            width: currentSize.actionSize,
            ...getCornerStyle({
                radius: radiuses.xs,
                shapeConfigs
            }),
            ...getFocusRingStyle({
                isFocusVisible: isChevronFocusVisible,
                colorKey: "default",
                borders,
                colors
            })
        } as Mutable<ViewStyle>,
        alphaInput: {
            ...getInputTextStyle({
                textStyle: typography.monoMediumSize,
                pointerType,
                typography
            }),
            width: currentSize.iconSize * 2
        } as Mutable<TextStyle>,
        input: {
            ...getInputTextStyle({
                textStyle: typography.monoMediumSize,
                pointerType,
                typography
            })
        } as Mutable<TextStyle>
    };

    return styles;
};
export default stylesheet;
